$(document).ready(function () {
  setTimeout(() => $('br').attr('aria-hidden', 'true'), 2000);

  setInterval(() => {
    $('li.featured-slide.slick-slide.slick-active').removeAttr('tabindex', '0');
    $('li.grid-item.slick-slide.slick-active').removeAttr('tabindex', '0');
    $('.reviews-box.slick-slide.slick-active').removeAttr('tabindex', '0');
  }, 500);
});

document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelector("#Slider-template--17227818893382__featured_collection_home_bzKWQh");

  if (slider) {
    // Handle both initialization cases
    const initButtons = () => {
      const buttons = slider.querySelectorAll(".slick-prev, .slick-next");
      buttons.forEach(button => {
        button.setAttribute("role", "button");
        button.setAttribute("tabindex", "0"); // Make them focusable
        button.setAttribute("aria-label",
          button.classList.contains("slick-prev") ?
            "Previous product" : "Next product"); // More specific label
        button.setAttribute("aria-controls", slider.id);
      });
    };

    // Check if already initialized
    if (slider.classList.contains('slick-initialized')) {
      initButtons();
    } else {
      slider.addEventListener("init", initButtons, { once: true });

      // Fallback timeout with cleanup
      const fallback = setTimeout(() => {
        if (slider.classList.contains('slick-initialized')) {
          initButtons();
        }
      }, 1000);

      // Clean up if initialization happens normally
      slider.addEventListener("init", () => clearTimeout(fallback), { once: true });
    }
  }
});
$(document).ready(function () {
  $('.heading_in ul.tabs li.active').append('<span class="visually-hidden">Selected</span>');

});


$(document).ready(function () {
  $(document).on('click', '.heading_in ul.tabs li', function () {
    $('.heading_in ul.tabs li .visually-hidden').remove();
    $('.heading_in ul.tabs li.active')
      .removeClass('active')
    $(this)
      .addClass('active')
      .append('<span class="visually-hidden">Selected</span>');
  });
});


$(document).ready(function () {

  var $triggerButton = $('#ShowPickupAvailabilityDrawer');
  var $drawer = $('pickup-availability-drawer');
  var $closeButton = $drawer.find('.pickup-availability-drawer-button');
  var $drawerHeading = $drawer.find('.pickup-availability-drawer-title');

  // Make <h2> focusable if not already
  $drawerHeading.attr('tabindex', '-1');

  // On trigger button click
  $triggerButton.on('click', function () {
    // Open drawer if needed
    $drawer.attr('open', '');

    // Small delay to wait for drawer animation/render
    setTimeout(function () {
      $drawerHeading.focus();
    }, 100);
  });

  // On Close button click
  $closeButton.on('click', function () {
    closeDrawerAndReturnFocus();
  });

  // On Escape key press
  $(document).on('keydown', function (e) {
    if (e.key === "Escape" && $drawer.is('[open]')) {
      closeDrawerAndReturnFocus();
    }
  });

  function closeDrawerAndReturnFocus() {
    $drawer.removeAttr('open');
    $triggerButton.focus();
  }

});

$(document).ready(function () {
  $('br').attr('aria-hidden', 'true');
});



jQuery(document).on("click", "#ShowPickupAvailabilityDrawer", function () {
  setTimeout(function () {
    jQuery(".pickup-availability-drawer-button").attr("tabindex", 0).focus();
  }, 1000);
});
